/**
 * 日期时间格式常量配置
 */

// ISO 8601格式，与服务器匹配的存储格式
export const DATE_STORE_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';

// 用于显示的本地日期时间格式
export const DATE_DISPLAY_FORMAT = 'MM-DD-YYYY HH:mm';